export const MagnifierSvg = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3281 19.5312C15.8586 19.5312 19.5312 15.8586 19.5312 11.3281C19.5312 6.79766 15.8586 3.125 11.3281 3.125C6.79766 3.125 3.125 6.79766 3.125 11.3281C3.125 15.8586 6.79766 19.5312 11.3281 19.5312Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1289 17.1289L21.875 21.875"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
